import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importe tes fichiers de traduction
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationAR from './locales/ar/translation.json'; // Importation du fichier de traduction arabe

// Les ressources de traduction
const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  ar: { // Ajout des ressources pour l'arabe
    translation: translationAR
  }
};

i18n
  .use(LanguageDetector) // Détecte la langue du navigateur
  .use(initReactI18next) // Passe i18n à react-i18next
  .init({
    resources,
    fallbackLng: 'fr', // Langue par défaut si celle du navigateur n'est pas disponible
    debug: true, // Active le mode debug pour voir les messages dans la console

    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    }
  });

export default i18n;
